import { formatMoney } from '../../helper/lib';
import moment from 'moment';

const ProjectDetailTypeA = ({ project, roomTypeExpress, totalArea }) => {
  const renderProjectDetailRow = (label, value) => (
    <tr className="align-top">
      <td width="150">
        <p className="fz-14 ff2">{label}</p>
      </td>
      <td>
        <p className="fz-14 fw-bold">{value ?? '-'}</p>
      </td>
    </tr>
  );

  const renderRoomDetails = (room, index) => (
    <>
      {renderProjectDetailRow(`Room Type ${index + 1}`, room?.roomTypes)}
      {renderProjectDetailRow(
        `Area Type ${index + 1}`,
        `${room?.m2 ?? '-'} m²`
      )}
      {renderProjectDetailRow(
        `Price Type ${index + 1}`,
        formatMoney(room?.project_price)
      )}
    </>
  );

  return (
    <div className="mt-5">
      <div className="mt-2 mb-4 d-flex justify-content-between align-items-center">
        <h4 className="fs-5 fw-bold">Design Information</h4>
        <a href={project?.so_invoice_url} download className="btn btn-success">
          Download Invoice
        </a>
      </div>
      <table>
        <tbody>
          {renderProjectDetailRow('Project No', project.orderNo)}
          {renderProjectDetailRow('Service', project.service)}
          <tr className="align-top">
            <td width="150">
              <p className="fz-14 ff2">Status</p>
            </td>
            <td>
              <div className="badge-new mb-3 badge-gray">
                {project?.status ?? '-'}
              </div>
            </td>
          </tr>
          {roomTypeExpress?.map((room, index) =>
            renderRoomDetails(room, index)
          )}
          {renderProjectDetailRow('Name', project?.name)}
          {renderProjectDetailRow('Phone Number', project?.phoneNumber)}
          {renderProjectDetailRow('Email', project?.email)}
          {renderProjectDetailRow('Total Area', `${totalArea ?? '-'} m²`)}
          {renderProjectDetailRow(
            'Total Cost',
            formatMoney(project?.total_order_price)
          )}
          {renderProjectDetailRow(
            'Last Update',
            project.updateAt
              ? moment(
                  project.updateAt.replaceAll(' WIB', ''),
                  'ddd MMM DD HH:mm:ss YYYY',
                  true
                ).format('ddd DD MMM YYYY HH:mm:ss ') + 'WIB'
              : project?.updatedAt
              ? moment(
                  project.updatedAt.replaceAll(' WIB', ''),
                  'ddd MMM DD HH:mm:ss YYYY',
                  true
                ).format('ddd DD MMM YYYY HH:mm:ss ') + 'WIB'
              : '-'
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectDetailTypeA;
